export default __webpack_public_path__ + "static/media/searchField.4cb22abc.png";